import { _ as _object_spread } from "@swc/helpers/_/_object_spread";
import { _ as _object_without_properties } from "@swc/helpers/_/_object_without_properties";
import React, { useCallback } from 'react';
import BiSpan from '@wix/da-bi/pkg/Components/BiSpan';
/**
 * A button made from a 'span'. For use in situations we need to nest buttons. Handles all the necessary events
 * to make it just like a real button
 */ const FakeButton = (_param)=>{
    var { onClick = ()=>null, onKeyDown = ()=>null } = _param, props = _object_without_properties(_param, [
        "onClick",
        "onKeyDown"
    ]);
    /**
   * Our fake button is mostly used in contexts where we need to nest a button inside of another button.
   *
   * Due to event propagation, keydown events trigger the fake button's click and the real button's click.
   * We don't want that.
   */ const handleKeyDownForFakeButton = useCallback((e)=>{
        switch(e.key){
            case ' ':
            case 'Space':
            case 'Enter':
                onClick(e);
                e.stopPropagation();
                break;
            default:
                break;
        }
        onKeyDown(e);
    }, [
        onKeyDown,
        onClick
    ]);
    return /*#__PURE__*/ React.createElement(BiSpan, _object_spread({
        tabIndex: 0,
        role: "button",
        onClick: onClick,
        onKeyDown: handleKeyDownForFakeButton
    }, props));
};
FakeButton.displayName = 'FakeButton';
export default FakeButton;
